import { render, staticRenderFns } from "./SectionGames.vue?vue&type=template&id=e2575c6a&scoped=true&"
import script from "./SectionGames.vue?vue&type=script&lang=ts&"
export * from "./SectionGames.vue?vue&type=script&lang=ts&"
import style0 from "./SectionGames.vue?vue&type=style&index=0&id=e2575c6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2575c6a",
  null
  
)

export default component.exports